import { Button, Grid } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
import TextInput from "../../../../components/hookForms/textField";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

export interface IDialogProps {
    open: boolean;
    data: {
        open: boolean;
        id: string;
        dataLeituraAnterior: string;
        dataLeituraAtual: string;
        dataProximaLeitura: string;
        dataEmissao: string;
        dataVencimento: string;
        dataReferencia: string;
        valorFatura: number;
    };
    onClose?: any;
}

export default function DialogDetails({ open, data, onClose }: IDialogProps) {
    const {
        control,
        reset,
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            dataLeituraAnterior: "",
            dataLeituraAtual: "",
            dataProximaLeitura: "",
            dataEmissao: "",
            dataVencimento: "",
            dataReferencia: "",
            valorFatura: 0,
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form>
                <DialogTitle>
                    Informações Básicas de Fatura
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="dataLeituraAnterior"
                                label="Data da Leitura Anterior"
                                control={control}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="dataLeituraAtual"
                                label="Data da Leitura Atual"
                                control={control}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="dataProximaLeitura"
                                label="Data da Próxima Leitura"
                                control={control}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput name="dataEmissao" label="Data de Emissão" control={control} disabled={true} />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="dataVencimento"
                                label="Data de Vencimento"
                                control={control}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TextInput
                                name="dataReferencia"
                                label="Data de Referência"
                                control={control}
                                disabled={true}
                            />
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <InputNumber
                                name="valorFatura"
                                label="Valor de Fatura (R$)"
                                control={control}
                                decimalScale={2}
                                maxLength={12}
                                disabled={true}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Voltar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
